import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdmissionComponent } from "src/app/view/admission/admission.component";
import { EntranceResultComponent } from "src/app/view/admission/entrance-result/entrance-result.component";
import { EntranceSyllabusComponent } from "src/app/view/admission/entrance-syllabus/entrance-syllabus.component";
import { FeeComponent } from "src/app/view/admission/fee/fee.component";
import { HoursComponent } from "src/app/view/admission/hours/hours.component";
import { HousesComponent } from "src/app/view/admission/houses/houses.component";
import { LibraryComponent } from "src/app/view/admission/library/library.component";
import { MessageToParentComponent } from "src/app/view/admission/message-to-parent/message-to-parent.component";
import { ProcessComponent } from "src/app/view/admission/process/process.component";
import { SubjectComponent } from "src/app/view/admission/subject/subject.component";
import { UniformComponent } from "src/app/view/admission/uniform/uniform.component";

const route:Routes=[
    {path:'',component:AdmissionComponent,children:[
        {path:'message',component:MessageToParentComponent},
        {path:'process',component:ProcessComponent},
        {path:'fee',component:FeeComponent},
        {path:'library',component:LibraryComponent},
        {path:'hours',component:HoursComponent},
        {path:'houses',component:HousesComponent},
        {path:'uniform',component:UniformComponent},
        {path:'entrance-syllabus',component:EntranceSyllabusComponent},
        {path:'entrance-result',component:EntranceResultComponent},
        {path:'subjects',component:SubjectComponent},
    ]}
]
@NgModule({
    imports:[
        RouterModule.forChild(route)
    ],
    exports:[
        RouterModule
    ]
})
export class AdmssionRoutingModule{}